export function stringSort( a, b ) {
   const sortA = ( a ?? '' ).toLowerCase();
   const sortB = ( b ?? '' ).toLowerCase();

   return ( sortA < sortB ) ? -1 : sortA > sortB ? 1 : 0;
}
